import React from 'react';
import { Link } from 'react-router-dom';
import VeritageLogo from './VeritageLogo';
import Dropdown from './Dropdown';
import { ArrowRight, Menu, Search } from './Icons';

export default function TopBar({ products, product, version, onProductChange, onVersionChange, onSearch, onMenu }) {
  const productCfg = products?.find((p) => p.id === product);
  const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

  return (
    <header className="vt-nav docs-nav">
      <button type="button" className="docs-nav-menu" onClick={onMenu} aria-label="Open navigation">
        <Menu size={20} />
      </button>

      <Link to="/" className="docs-nav-brand" aria-label="Veritage Docs home">
        <VeritageLogo height={28} />
        <span className="docs-nav-divider" aria-hidden="true" />
        <span className="docs-nav-title">Docs</span>
      </Link>

      {products?.length > 0 && (
        <div className="docs-nav-pickers">
          {products.length > 1 && (
            <Dropdown label="Product" value={product} options={products} onChange={onProductChange} minWidth={180} />
          )}
          {productCfg && (
            <Dropdown label="Version" value={version} options={productCfg.versions} onChange={onVersionChange} />
          )}
        </div>
      )}

      <button type="button" className="docs-search-trigger" onClick={onSearch}>
        <Search size={16} />
        <span>Search docs</span>
        <kbd>{isMac ? '⌘' : 'Ctrl'} K</kbd>
      </button>

      <nav className="docs-nav-links" aria-label="Veritage">
        <a className="vt-nav-link" href="https://veritage.io">Home</a>
        <a className="vt-nav-link" href="https://playground.veritage.io">Playground</a>
      </nav>

      <a className="vt-btn vt-btn--sm docs-nav-cta" href="https://app.veritage.io">
        Get API keys
        <span className="vt-btn-arrow"><ArrowRight size={14} /></span>
      </a>
    </header>
  );
}
